/**
 * Purchase option → variant.
 *
 * Writes the chosen row's variant id (data-variant on the po3 radio) into
 * the real add-to-cart form and mirrors it in the URL, so a reload lands
 * on the same variant. Only loaded when the product has more than one
 * variant; with a single variant there is nothing to switch.
 *
 * Dawn's own variant picker is not involved on purpose: driving it would
 * re-render the buy box and drop the po3 selection.
 */
(function () {
  function fieldset() {
    return document.querySelector('fieldset.po3');
  }

  // Same rule as purchase-options.js: Shop Pay's installments form shares
  // the action, only the real form lives inside <product-form>.
  function form() {
    return (
      document.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]:not([id*="installment"])')
    );
  }

  function idInput() {
    var f = form();
    return f ? f.querySelector('input[name="id"]') : null;
  }

  function sync() {
    var fs = fieldset();
    var el = idInput();
    if (!fs || !el) return;

    var option = fs.querySelector('[name="purchase_option"]:checked');
    if (!option) return;

    var variant = option.getAttribute('data-variant');
    if (!variant) return;

    if (el.value !== variant) {
      el.value = variant;
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }

    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get('variant') !== variant) {
        url.searchParams.set('variant', variant);
        window.history.replaceState({}, '', url.toString());
      }
    } catch (e) {
      /* the URL is a convenience, the form field is what matters */
    }
  }

  function boot() {
    var fs = fieldset();
    var f = form();
    if (!fs || !f) return false;

    fs.addEventListener('change', sync);
    // Capture phase: runs before the form is serialized by anything else.
    f.addEventListener('submit', sync, true);
    var button = f.querySelector('[type="submit"]');
    if (button) button.addEventListener('click', sync, true);

    sync();
    return true;
  }

  var tries = 0;
  var timer = setInterval(function () {
    if (boot() || ++tries > 60) clearInterval(timer);
  }, 250);
})();
